//对象数组去重
export const arrayUnique = (arr, key) => {
    let obj = {};
    return arr.reduce((item, next) => {
        obj[next[key]] ? '' : obj[next[key]] = true && item.push(next);
        return item;
    }, []); 
};